import {Deserializable} from "./deserializable.model";

export class TimeframeSurcharge {

    // :; A service rule is assocuated with document types.

job_service_rule_id: number;

timeframe_surcharge_id: number;
timeframe_surcharge_name: string;
timeframe_surcharge_description: string;
timeframe_from: string;
timeframe_to: string;
time_frame_type: string;
timeframe_duration_ms: number;
is_active: any;
colour: string;
icon: string;

surcharge_percentage: number;


  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): TimeframeSurcharge {
    Object.assign(this, input);

    return this;
  }


}
